module.exports = "<highcharts-chart [Highcharts]=\"Highcharts\" [options]=\"chartOptionsdos\" style=\"height: 230px;  display: block;\">\n</highcharts-chart>"